<template>
	<div id="paymentModalComponent">
		<button class="btn-link" data-toggle="modal" data-target=".paymen-modal-component" ref="showPayment" v-show="false" @click="setPaymentModal">Show Payment</button>
		<button ref="btnGetPayment" @click="showPaymentLocal" v-show="false">Buscar Pagos</button>
		<button ref="btnGetTypePayment" @click="getTypePaymentLocal" v-show="false">Buscar Formas de pago</button>

		<div v-if="modalLocal" class="modal fade paymen-modal-component" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">
							Pagos {{title}} Nº {{idLocal}}
							<span v-if="totalToPaid > 0"> - Monto a Pagar ${{methodFormatNumber(totalToPaid)}}</span>
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div v-if="!searchingPayment">
							<table class="table table-sm table-12">
								<thead>
									<tr>
										<th class="text-center">#</th>
										<th class="text-center">Forma de Pago</th>
										<th class="text-center">Monto</th>
										<th class="text-center">Banco</th>
										<th class="text-center">Codigo</th>
										<th class="text-center">Descripción</th>
										<th class="text-center">Fecha</th>
										<th class="text-right" style="width: 40px;"><i class="fas fa-plus-square text-primary pointer" @click="setPlusPayment"></i></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listPayments" :key="index">
										<td>{{item.payment.id}}</td>
										<td>{{item.payment.typePayment}}</td>
										<td class="text-right">{{methodFormatNumber(item.payment.amount)}}</td>
										<td class="text-center">{{item.payment.bank}}</td>
										<td class="text-center">{{item.payment.code}}</td>
										<td>{{item.payment.description}}</td>
										<td class="text-center">{{item.payment.transaction_date}}</td>
										<td class="text-right">
											<i class="fas fa-exclamation-triangle text-warning margin-right5" v-show="item.payment.status_id == 40" title="Pago Rechazado"></i>
											<i class="far fa-trash-alt pointer text-danger margin-right5" v-show="item.payment.status_id != 39" @click="deletePaymentLocal(item.payment.id)"></i>
											<i class="fas fa-check text-success margin-right5" v-show="item.payment.status_id == 39"></i>
											<i class="fas fa-file-upload text-info pointer" v-show="item.exists == 1" @click="showUploadDocumentModalComponentLocal(item.id)"></i>
										</td>
									</tr>
									<tr v-show="plusPayment">
										<td class="text-center">{{ dataPayment.id }}</td>
										<td class="text-left">
											<select v-model="dataPayment.type_payment_id"  style="width: 150px;">
												<option v-for="(it, ind) in listTypePayments" :key="ind" :value="it.id">{{ it.name }}</option>
											</select>
										</td>
										<td class="text-right"><input type="number" class="text-right" v-model="dataPayment.amount" style="width: 75px;"/></td>
										<td>
											<select v-model="dataPayment.bank_id">
												<option v-for="(it, ind) in listBanks" :key="ind" :value="it.id">{{ it.name }}</option>
											</select>
										</td>
										<td><input type="text" class="text-right" v-model="dataPayment.code" style="width: 60px;"/></td>
										<td><input type="text" class="text-right" v-model="dataPayment.description" style="width: 75px;"/></td>
										<td><input type="date" class="text-right" v-model="dataPayment.transaction_date" style="width: 115px;"/></td>
										<td class="text-right">
											<i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveOrderPaymentLocal()"></i>
											<i class="fas fa-minus-circle pointer text-danger" @click="plusPayment = !plusPayment"></i>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr style="font-size: 18px">
										<td colspan="2" class="text-right">Total pagos:</td>
										<td class="text-right"><b>{{ methodFormatNumber(totalPayments) }}</b></td>
									</tr>
								</tfoot>
							</table>
						</div>
						<div v-else>
							<div class="alert alert-info" role="alert">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
								Buscando pagos ...
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="!searchingPayment" :id="'payments' + idLocal">
				<table class="table table-sm table-12">
					<thead>
						<tr>
							<th class="text-center">ID</th>
							<th class="text-center">Forma de Pago</th>
							<th class="text-center">Monto</th>
							<th class="text-center">Banco</th>
							<th class="text-center">Codigo</th>
							<th class="text-center">Descripción</th>
							<th class="text-center">Fecha</th>
							<th class="text-right" style="width: 40px;"><i class="fas fa-plus-square text-primary pointer" @click="setPlusPayment"></i></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listPayments" :key="index">
							<td class="text-center">{{item.payment.id}}</td>
							<td>{{item.payment.typePayment}}</td>
							<td class="text-right">{{methodFormatNumber(item.payment.amount)}}</td>
							<td class="text-center">{{item.payment.bank}}</td>
							<td class="text-center">{{item.payment.code}}</td>
							<td>{{item.payment.description}}</td>
							<td class="text-center">{{item.payment.transaction_date}}</td>
							<td class="text-right">
								<i class="fas fa-exclamation-triangle text-warning margin-right5" v-show="item.payment.status_id == 40" title="Pago Rechazado"></i>
								<i class="far fa-trash-alt pointer text-danger margin-right5" v-show="item.payment.status_id != 39" @click="deletePaymentLocal(item.payment.id)"></i>
								<i class="fas fa-check text-success margin-right5" v-show="item.payment.status_id == 39"></i>
								<i class="fas fa-file-upload text-info pointer" v-show="item.exists == 1" @click="showUploadDocumentModalComponentLocal(item.id)"></i>
							</td>
						</tr>
						<tr v-show="plusPayment">
							<td class="text-center">{{ dataPayment.id }}</td>
							<td class="text-left">
								<select v-model="dataPayment.type_payment_id"  style="width: 150px;">
									<option v-for="(it, ind) in listTypePayments" :key="ind" :value="it.id">{{ it.name }}</option>
								</select>
							</td>
							<td class="text-right"><input type="number" class="text-right" v-model="dataPayment.amount" style="width: 75px;"/></td>
							<td>
								<select v-model="dataPayment.bank_id">
									<option v-for="(it, ind) in listBanks" :key="ind" :value="it.id">{{ it.name }}</option>
								</select>
							</td>
							<td><input type="text" class="text-right" v-model="dataPayment.code" style="width: 60px;"/></td>
							<td><input type="text" class="text-right" v-model="dataPayment.description" style="width: 75px;"/></td>
							<td><input type="date" class="text-right" v-model="dataPayment.transaction_date" style="width: 115px;"/></td>
							<td class="text-right">
								<i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveOrderPaymentLocal()"></i>
								<i class="fas fa-minus-circle pointer text-danger" @click="plusPayment = !plusPayment"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else>
				<div class="alert alert-info" role="alert">
					<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>
					Buscando pagos ...
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import typePayment from '@/mixins/generals/typePayment.js'
	import payment from '@/mixins/generals/payment.js'
	
	export default {
		name: 'PaymentModalComponent',
		mixins: [mixin, errors, axiosAction, typePayment, payment],
		props: ['id', 'controller', 'title', 'modal', 'totalToPaid', 'uploadDocument'],
		data () {
			return {
				plusPayment: false,
				modalLocal: this.modal,
				searchingPayment: false,
				paymentId: 0
			}
		},
		computed: {
			listBanks() {
				let listBanks = []
				this.dataPayment.bank_id = ''
				let index = this.listTypePayments.map((el) => parseInt(el.id)).indexOf(parseInt(this.dataPayment.type_payment_id))
				if(index > -1)
					listBanks = this.listTypePayments[index].listBanks
				return listBanks
			},
			idLocal() {
				if(this.id == 0) {
					this.listPayments = []
				} else if (this.id > 0) {
					this.searchingPayment = true
					this.listPayments = []
					this.getPaymentByController(this.id, this.controller)
				}
				return this.id
			},
			totalPayments() {
                let total = this.listPayments.reduce(function(a, b) { 
                                let c = parseInt(b.payment.amount)
                                return a + parseInt(c)
                            }, 0);
                return total.toFixed(0)
			}
		},
		methods: {
			clearModal() {
				console.log('Limpiar')
			},
			deletePaymentLocal(id) {
				if(confirm('¿Está seguro de ELIMINAR el pago?')){
					this.deletePayment(this.controller, this.id, id)
				}
			},
			deletePaymentResultLocal(response) {
				this.$emit('removeRow', this.idLocal, response.data.data)
			},
			getTypePaymentLocal() {
				this.getAllTypePayments()
			},
			getAllTypePaymentsResultLocal(response) {},
			getPaymentByControllerResultLocal(response) { this.searchingPayment = false },
			loadFile() {},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'deletePaymentResult': this.deletePaymentResult(response); break;
					case 'getAllTypePaymentsResult': this.getAllTypePaymentsResult(response); break;
					case 'getPaymentByControllerResult': this.getPaymentByControllerResult(response); break;
					case 'savePaymentResult': this.savePaymentResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			saveOrderPaymentLocal() {
				this.savePayment(this.controller, this.idLocal)
			},
			savePaymentResultLocal(response) {
				if(response.data.success === true) {
					this.plusPayment = false
					this.$emit('addRow', this.idLocal, response.data.data)
				}
			},
			setDataPaymentModal() {
				this.dataPayment.id = 0
				this.dataPayment.type_payment_id = 1
				this.dataPayment.amount = 0
				this.dataPayment.bank_id = 0
				this.dataPayment.code = ''
				this.dataPayment.description = ''
				this.dataPayment.transaction_date = this.currentDate()
				if(this.listTypePayments.length == 0) {
					this.getTypePaymentLocal()
				}
			},
			setPaymentModal() {
				this.plusPayment = false
				this.setDataPaymentModal()
			},
			setPlusPayment() {
				this.setDataPaymentModal()
				this.plusPayment = true
			},
			showPaymentLocal() {
				//this.getPaymentByController(this.idLocal, this.controller)
			},
			showUploadDocumentModalComponentLocal(id) {
				this.paymentId = id
				this.$emit('uploadDocument', id)
			}
		},
		components: {
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
